import { cva } from 'class-variance-authority';

export const raceSummarySwatchVariants = cva('size-5 shrink-0 rounded-[3px]', {
  variants: {
    variant: {
      onCourse: 'relative overflow-hidden bg-proportion-bar-on-course',
      finished: 'bg-proportion-bar-finished',
    },
  },
});

export const raceSummarySwatchStripeVariants = cva(
  'absolute inset-0 bg-proportion-bar-on-course-stripe'
);
